import React from "react";
import { AiOutlineSetting } from "react-icons/ai";
import { Link } from "react-router-dom";
import { NotifHeaderContainer } from "../styled/dashboard";

const Header = ({
  isSetMenuOpen,
  setIsSetMenuOpen,
  settingMenuClose,
  isDelete,
  setIsDelete,
  readAllNotis,
  active,
}) => {
  return (
    <NotifHeaderContainer>
      <div className="inner">
        <div className="monoti">
          <Link to="/" className="logo">
            <div>MONOTI</div>
          </Link>
        </div>
        {active === 0 && (
          <div className="toggle">
            {isDelete ? (
              <button className="cancel" onClick={settingMenuClose}>
                취소
              </button>
            ) : (
              <div className="setting">
                <button onClick={() => setIsSetMenuOpen(!isSetMenuOpen)}>
                  <AiOutlineSetting />
                </button>
                {isSetMenuOpen && (
                  <ul>
                    <li>
                      <button onClick={readAllNotis}>모두읽음</button>
                    </li>
                    <li>
                      <button onClick={() => setIsDelete(true)}>알림삭제</button>
                    </li>
                  </ul>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </NotifHeaderContainer>
  );
};

export default Header;
